// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/automation-management.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/automation-management/automation-management.js';

mount([g0]);
